import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { SecondaryColor } from "node-library/dist/colors";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface Props {
	label: string;
	icon: React.ReactNode;

	onRowClick?: () => void;
	onDoubleClick?: () => void;
	selected: boolean;
	children?: React.ReactNode;
	// userSpecifications: Array<FrontendSampleSpecification>;
	// setUserSpecifications: React.Dispatch<
	// 	React.SetStateAction<Array<FrontendSampleSpecification>>
	// >;
}

export default function SpecificationSubFolderRow(props: Props) {
	const { t: translation } = useTranslation();

	const [uploadSpecModalOpen, setUploadSpecModalOpen] =
		useState<boolean>(false);

	const handleClick = () => {
		// If onRowClick is provided, call it
		if (props.onRowClick) {
			props.onRowClick();
		}

		// Toggle the expanded state
	};
	const handleDoubleClick = () => {
		// If onRowClick is provided, call it
		if (props.onDoubleClick) {
			props.onDoubleClick();
		}

		// Toggle the expanded state
	};

	return (
		<div>
			<div
				className={`profile-spec-matrix-folder-row ${
					props.selected ? `profile-spec-matrix-folder-row-selected` : ``
				}`}
				onClick={handleClick}
				onDoubleClick={handleDoubleClick}
			>
				<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
					{props.icon}
					<div className="typography-body-02">{props.label}</div>
				</div>
			</div>
		</div>
	);
}
